import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SessionStorageService {
  get<T>(key: string): T | null {
    const value = sessionStorage.getItem(key);
    if (!value) return null;
    try {
      return JSON.parse(value) as T;
    } catch (e) {
      console.warn(e);
      return null;
    }
  }

  set(key: string, value: unknown): this {
    sessionStorage.setItem(key, JSON.stringify(value));
    return this;
  }

  remove(key: string): this {
    sessionStorage.removeItem(key);
    return this;
  }
}
